import React from 'react';
import FigmaBadge from '../Elements/FigmaBadge';
import urlHelper from '../Helpers/urlHelper';

export default class VPricingDetailBaseItem {
  constructor(item) {
    if (item === undefined) {
      this.AnnualCallsToShopperCost = '';
      this.AnnualMiscCost3 = '';
      this.AnnualRecruitingCost = '';
      this.AnnualTestcastorCost = '';
      this.AssistantProjMgrDailyCost = '';
      this.AssistantProjMgrDailyCostOffice = '';
      this.AssistantProjMgrDailyCostOverride = '';
      this.AssistantProjMgrDaysPerCycle = '';
      this.BankChargesPerCycle = '';
      this.CardCostPerEval = '';
      this.CaseCostPerEval = '';
      this.CaseCostPerEval1 = '';
      this.CaseCostPerEval2 = '';
      this.CdrcostPerEval = '';
      this.ClientRevenueNotes = '';
      this.CommissionPct = '';
      this.CostFromEditOffice = '';
      this.CountryName = '';
      this.CreatedBy = '';
      this.CreatedByName = '';
      this.CreatedOn = '';
      this.CurrencyCode = '';
      this.CurrencyRate = '';
      this.CurrencySymbol = '';
      this.Dnepct = '';
      this.DvdcostPerEval = '';
      this.EditDataCheckDailyCost = '';
      this.EditDataCheckDailyCostOffice = '';
      this.EditDataCheckDailyCostOverride = '';
      this.EditDataCheckDaysPerCycle = '';
      this.EditingCostNotes = '';
      this.EditorCostPerEval = '';
      this.EditorCostPerHour = '';
      this.EmpBenefitsDailyCost = '';
      this.EmpBenefitsDailyCostOffice = '';
      this.EmpBenefitsDailyCostOverride = '';
      this.EmployeeCostNotes = '';
      this.EvalBonusPerCycle = '';
      this.EvaluatorFeeNotes = '';
      this.EvaluatorRecruitingCostNotes = '';
      this.ExtDataCheckPerEval = '';
      this.FieldworkCycle = '';
      this.FieldworkCycleCode = '';
      this.FieldWorkNotes = '';
      this.FinalizedInverseRate = '';
      this.FinalizedOfficeInverseRate = '';
      this.FinalizedOn = '';
      this.FinalizedOpportunityInverseRate = '';
      this.FinalizedRate = '';
      this.IcrfeeCostPerEval = '';
      this.IsCurrentVersion = '';
      this.IsOwningOffice = '';
      this.IsVideoCdr = '';
      this.IsVideoDvd = '';
      this.IvrfeeCostPerEval = '';
      this.IvrfeePerEval = '';
      this.LengthVideoShopHours = '';
      this.MailingCostPerEval = '';
      this.MarkUpNotes = '';
      this.MiscCostPerCycle1 = '';
      this.MiscCostPerCycle2 = '';
      this.MiscCostPerCycle3 = '';
      this.MiscCostPerCycleText1 = '';
      this.MiscCostPerCycleText2 = '';
      this.MiscCostPerCycleText3 = '';
      this.MiscCostText1 = '';
      this.MiscCostText2 = '';
      this.MiscCostText3 = '';
      this.ModifiedBy = '';
      this.ModifiedByName = '';
      this.ModifiedOn = '';
      this.Name = '';
      this.NumCyclesPerYr = '';
      this.OfficeId = '';
      this.OfficeName = '';
      this.OperationsMgrDailyCost = '';
      this.OperationsMgrDailyCostOffice = '';
      this.OperationsMgrDailyCostOverride = '';
      this.OperationsMgrDaysPerCycle = '';
      this.OpportunityCurrencyCode = '';
      this.OpportunityCurrencyInverseRate = '';
      this.OpportunityCurrencyRate = '';
      this.OpportunityCurrencySymbol = '';
      this.OpportunityOfficeId = '';
      this.OpportunityOfficeName = '';
      this.OverheadRatePct = '';
      this.OverrideFee = '';
      this.RoundFee = '';
      this.OwningOfficeIsChecking = '';
      this.OwningOfficeIsEditing = '';
      this.OwningOfficeIsTranslating = '';
      this.PanelMgrRecruiterDailyCost = '';
      this.PanelMgrRecruiterDailyCostOffice = '';
      this.PanelMgrRecruiterDailyCostOverride = '';
      this.PanelMgrRecruiterDaysPerCycle = '';
      this.PayrollTaxPct = '';
      this.PricingDetailId = '';
      this.PricingFeeBase = '';
      this.PricingId = '';
      this.ProjMgrDailyCost = '';
      this.ProjMgrDailyCostOffice = '';
      this.ProjMgrDailyCostOverride = '';
      this.ProjMgrDaysPerCycle = '';
      this.ServiceId = '';
      this.ServiceName = '';
      this.ServiceTypeCode = '';
      this.ShippingCostPerEval = '';
      this.ShopperTravelCostNotes = '';
      this.SMCostPerEval = '';
      this.SMCostPerEvalOverride = '';
      this.Status = '';
      this.StatusCode = '';
      this.StreamingCostPerHour = '';
      this.TeamLeadDailyCost = '';
      this.TeamLeadDailyCostOffice = '';
      this.TeamLeadDailyCostOverride = '';
      this.TeamLeadDaysPerCycle = '';
      this.TimeCaptureCostPerHour = '';
      this.TransCostPerEval = '';
      this.Version = '';
      this.VideoCaseType = '';
      this.VideoCaseTypeCode = '';
      this.VideoCostsNotes = '';
      this.VocazillaAvgCallLengthMinutes = '';
      this.VocazillaCostPerEval = '';
      this.EvalBonusAnnually = '';
      this.EvalBonusPct = '';
      this.BankChargesAnnually = '';
      this.BankChargesPct = '';
    } else {
      this.EvalBonusAnnually = '';
      this.EvalBonusPct = '';
      this.AnnualCallsToShopperCost = VPricingDetailBaseItem.ConvertToDecimal(item.annualCallsToShopperCost);
      this.AnnualMiscCost3 = VPricingDetailBaseItem.ConvertToDecimal(item.annualMiscCost3);
      this.AnnualRecruitingCost = VPricingDetailBaseItem.ConvertToDecimal(item.annualRecruitingCost);
      this.AnnualTestcastorCost = item.annualTestcastorCost;
      this.AssistantProjMgrDailyCost = item.assistantProjMgrDailyCost;
      this.AssistantProjMgrDailyCostOffice = VPricingDetailBaseItem.ConvertToDecimal(
        item.assistantProjMgrDailyCostOffice
      );
      this.AssistantProjMgrDailyCostOverride = item.assistantProjMgrDailyCostOverride;
      this.AssistantProjMgrDaysPerCycle = VPricingDetailBaseItem.ConvertToDecimal(item.assistantProjMgrDaysPerCycle);
      this.BankChargesPerCycle = VPricingDetailBaseItem.ConvertToDecimal(item.bankChargesPerCycle);
      this.CardCostPerEval = item.cardCostPerEval;
      this.CaseCostPerEval = item.caseCostPerEval;
      this.CaseCostPerEval1 = item.caseCostPerEval1;
      this.CaseCostPerEval2 = item.caseCostPerEval2;
      this.CdrcostPerEval = item.cdrcostPerEval;
      this.ClientRevenueNotes = item.clientRevenueNotes;
      this.CommissionPct = item.commissionPct;
      this.CostFromEditOffice = item.costFromEditOffice;
      this.CountryName = item.countryName;
      this.CreatedBy = item.createdBy;
      this.CreatedByName = item.createdByName;
      this.CreatedOn = item.createdOn;
      this.CurrencyCode = item.currencyCode;
      this.CurrencyRate = item.currencyRate;
      this.CurrencySymbol = item.currencySymbol;
      this.Dnepct = item.dnepct;
      this.DvdcostPerEval = item.dvdcostPerEval;
      this.EditDataCheckDailyCost = item.editDataCheckDailyCost;
      this.EditDataCheckDailyCostOffice = item.editDataCheckDailyCostOffice;
      this.EditDataCheckDailyCostOverride = item.editDataCheckDailyCostOverride;
      this.EditDataCheckDaysPerCycle = VPricingDetailBaseItem.ConvertToDecimal(item.editDataCheckDaysPerCycle);
      this.EditingCostNotes = item.editingCostNotes;
      this.EditorCostPerEval = VPricingDetailBaseItem.ConvertToDecimal(item.editorCostPerEval);
      this.EditorCostPerHour = item.editorCostPerHour;
      this.EmpBenefitsDailyCost = item.empBenefitsDailyCost;
      this.EmpBenefitsDailyCostOffice = item.empBenefitsDailyCostOffice;
      this.EmpBenefitsDailyCostOverride = item.empBenefitsDailyCostOverride;
      this.EmployeeCostNotes = item.employeeCostNotes;
      this.EvalBonusPerCycle = VPricingDetailBaseItem.ConvertToDecimal(item.evalBonusPerCycle);
      this.EvaluatorFeeNotes = item.evaluatorFeeNotes;
      this.EvaluatorRecruitingCostNotes = item.evaluatorRecruitingCostNotes;
      this.ExtDataCheckPerEval = VPricingDetailBaseItem.ConvertToDecimal(item.extDataCheckPerEval);
      this.FieldworkCycle = item.fieldworkCycle;
      this.FieldworkCycleCode = item.fieldworkCycleCode;
      this.FieldWorkNotes = item.fieldWorkNotes;
      this.FinalizedInverseRate = item.finalizedInverseRate;
      this.FinalizedOfficeInverseRate = item.finalizedOfficeInverseRate;
      this.FinalizedOn = item.finalizedOn;
      this.FinalizedOpportunityInverseRate = item.finalizedOpportunityInverseRate;
      this.FinalizedRate = item.finalizedRate;
      this.IcrfeeCostPerEval = item.icrfeeCostPerEval;
      this.IsCurrentVersion = item.isCurrentVersion;
      this.IsOwningOffice = item.isOwningOffice;
      this.IsVideoCdr = item.isVideoCdr;
      this.IsVideoDvd = item.isVideoDvd;
      this.IvrfeeCostPerEval = item.ivrfeeCostPerEval;
      this.IvrfeePerEval = item.ivrfeePerEval;
      this.LengthVideoShopHours = item.lengthVideoShopHours;
      this.MailingCostPerEval = item.mailingCostPerEval;
      this.MarkUpNotes = item.markUpNotes;
      this.MiscCostPerCycle1 = VPricingDetailBaseItem.ConvertToDecimal(item.miscCostPerCycle1);
      this.MiscCostPerCycle2 = VPricingDetailBaseItem.ConvertToDecimal(item.miscCostPerCycle2);
      this.MiscCostPerCycle3 = VPricingDetailBaseItem.ConvertToDecimal(item.miscCostPerCycle3);
      this.MiscCostPerCycleText1 = item.miscCostPerCycleText1;
      this.MiscCostPerCycleText2 = item.miscCostPerCycleText2;
      this.MiscCostPerCycleText3 = item.miscCostPerCycleText3;
      this.MiscCostText1 = item.miscCostText1;
      this.MiscCostText2 = item.miscCostText2;
      this.MiscCostText3 = item.miscCostText3;
      this.ModifiedBy = item.modifiedBy;
      this.ModifiedByName = item.modifiedByName;
      this.ModifiedOn = item.modifiedOn;
      this.Name = item.name;
      this.NumCyclesPerYr = item.numCyclesPerYr;
      this.OfficeId = item.officeId;
      this.OfficeName = item.officeName;
      this.OperationsMgrDailyCost = item.operationsMgrDailyCost;
      this.OperationsMgrDailyCostOffice = item.operationsMgrDailyCostOffice;
      this.OperationsMgrDailyCostOverride = item.operationsMgrDailyCostOverride;
      this.OperationsMgrDaysPerCycle = VPricingDetailBaseItem.ConvertToDecimal(item.operationsMgrDaysPerCycle);
      this.OpportunityCurrencyCode = item.opportunityCurrencyCode;
      this.OpportunityCurrencyInverseRate = item.opportunityCurrencyInverseRate;
      this.OpportunityCurrencyRate = item.opportunityCurrencyRate;
      this.OpportunityCurrencySymbol = item.opportunityCurrencySymbol;
      this.OpportunityOfficeId = item.opportunityOfficeId;
      this.OpportunityOfficeName = item.opportunityOfficeName;
      this.OverheadRatePct = item.overheadRatePct;
      this.OverrideFee = item.overrideFee;
      this.RoundFee = item.roundFee;
      this.OwningOfficeIsChecking = item.owningOfficeIsChecking;
      this.OwningOfficeIsEditing = item.owningOfficeIsEditing;
      this.OwningOfficeIsTranslating = item.owningOfficeIsTranslating;
      this.PanelMgrRecruiterDailyCost = item.panelMgrRecruiterDailyCost;
      this.PanelMgrRecruiterDailyCostOffice = item.panelMgrRecruiterDailyCostOffice;
      this.PanelMgrRecruiterDailyCostOverride = item.panelMgrRecruiterDailyCostOverride;
      this.PanelMgrRecruiterDaysPerCycle = VPricingDetailBaseItem.ConvertToDecimal(item.panelMgrRecruiterDaysPerCycle);
      this.PayrollTaxPct = item.payrollTaxPct;
      this.PricingDetailId = item.pricingDetailId;
      this.PricingFeeBase = item.pricingFeeBase;
      this.PricingId = item.pricingId;
      this.ProjMgrDailyCost = item.projMgrDailyCost;
      this.ProjMgrDailyCostOffice = VPricingDetailBaseItem.ConvertToDecimal(item.projMgrDailyCostOffice);
      this.ProjMgrDailyCostOverride = item.projMgrDailyCostOverride;
      this.ProjMgrDaysPerCycle = VPricingDetailBaseItem.ConvertToDecimal(item.projMgrDaysPerCycle);
      this.ServiceId = item.serviceId;
      this.ServiceName = item.serviceName;
      this.ServiceTypeCode = item.serviceTypeCode;
      this.ShippingCostPerEval = item.shippingCostPerEval;
      this.ShopperTravelCostNotes = item.shopperTravelCostNotes;
      this.SMCostPerEval = item.smcostPerEval;
      this.SMCostPerEvalOrig = item.smcostPerEval;
      this.SMCostPerEvalOverride = item.smcostPerEvalOverride;
      this.SMCostPerEvalConv = item.smcostPerEval * item.currencyRate;
      this.Status = item.status;
      this.StatusCode = item.statusCode;
      this.StreamingCostPerHour = item.streamingCostPerHour;
      this.TeamLeadDailyCost = item.teamLeadDailyCost;
      this.TeamLeadDailyCostOffice = item.teamLeadDailyCostOffice;
      this.TeamLeadDailyCostOverride = item.teamLeadDailyCostOverride;
      this.TeamLeadDaysPerCycle = VPricingDetailBaseItem.ConvertToDecimal(item.teamLeadDaysPerCycle);
      this.TimeCaptureCostPerHour = item.timeCaptureCostPerHour;
      this.TransCostPerEval = VPricingDetailBaseItem.ConvertToDecimal(item.transCostPerEval);
      this.Version = item.version;
      this.VideoCaseType = item.videoCaseType;
      this.VideoCaseTypeCode = item.videoCaseTypeCode;
      this.VideoCostsNotes = item.videoCostsNotes;
      this.VocazillaAvgCallLengthMinutes = item.vocazillaAvgCallLengthMinutes;
      this.VocazillaCostPerEval = item.vocazillaCostPerEval;
    }
    this.OperationsMgrDailyCostOfficeOverrideCur = 0;
    this.PanelMgrRecruiterDailyCostOfficeOverrideCur = 0;
  }
  static ConvertToDecimal(value) {
    try {
      return parseFloat(Number(value)).toFixed(2);
    } catch (error) {
      return value;
    }
  }
  static nameOfTheItemDetailList() {
    return 'Pricing Detail';
  }

  static NameOfTheIdField() {
    return 'PricingDetailId';
  }

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];
  static MoneyFields = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];

  static BoolFields = [];

  static FieldsToShowInListTable = [];
  static FieldsToShowInDataTable() {
    return [
      { label: 'Select', orderById: '', data: VPricingDetailBaseItem.getSelectedCellContent, tableminWidth: '70px' },
      { label: 'Name', orderById: 'Name', data: (item) => VPricingDetailBaseItem.getPricingDetail(item), minWidth: 50 },
      {
        label: 'Is Selected?',
        orderById: 'IsCurrentVersion',
        data: VPricingDetailBaseItem.GetSelectedStatus,
        minWidth: 50,
      },
      { label: 'Version', orderById: 'Version', data: 'Version', minWidth: 50 },
      { label: 'Currency', orderById: 'CurrencySymbol', data: 'CurrencySymbol', minWidth: 50 },
      { label: 'Revenue', orderById: 'Revenue', data: 'RevenuePct', minWidth: 50 },
      { label: 'Cost', orderById: 'Cost', data: 'Cost', minWidth: 50 },
      { label: 'FW Revenue %', orderById: 'RevenuePct', data: 'RevenuePct', minWidth: 50 },
      { label: 'FW Fee', orderById: 'FWFee', data: 'FWFee', minWidth: 50 },
      { label: '# Evals', orderById: 'NumEvalsTotal', data: 'NumEvalsTotal', minWidth: 50 },
      { label: 'Status', orderById: 'Status', data: 'Status', minWidth: 50 },
      { label: 'Modified By', orderById: 'ModifiedByName', data: 'ModifiedByName', minWidth: 50 },
      { label: 'Modified On', orderById: 'ModifiedOn', data: 'ModifiedOn', minWidth: 50 },
    ];
  }

  static GetSelectedStatus(item) {
    return <div className='ponter'>{<FigmaBadge Active={item.IsCurrentVersion} />}</div>;
  }
  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            VPricingDetailBaseItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnSelect(item, selected) {}

  static getPricingDetail(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.Name,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'sales_PricingDetailList/search',
      `PricingDetailId=${item.PricingDetailId}`,
      'Open up in a new tab'
    );
  }
}
